module.exports = "/assets/75b8de1b729e1a0fe6cac121773bec4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OK.png
// module id = 2807
// module chunks = 0